export default __webpack_public_path__ + "static/media/2.1f6a282a.jpg";